<h3-linked-radio-button-dropdown
  [dropdownTitle]="'Submission history'"
  [dropdownItems]="submissionItems$ | async"
  matMenuClass="submissions-menu"
>
  @if (canCompareAnswers$ | async) {
    <button
      mat-button
      class="item-row compare-answers"
      [disabled]="overlayIsOpen$ | async"
      (click)="openOverlay()"
    >
      <mat-icon
        *ngIf="(overlayIsOpen$ | async) !== true"
        class="material-icons compare-answer-icon"
        >compare_arrows</mat-icon
      >
      <mat-icon
        *ngIf="overlayIsOpen$ | async"
        class="material-icons compare-answer-icon"
        >done</mat-icon
      >
      <span class="compare-answers-label">Compare Answers</span>
    </button>
  }
</h3-linked-radio-button-dropdown>

<ng-template #rejected>
  <div class="rejected">
    <mat-icon class="material-symbols-outlined" matTooltip="Rejected"
      >warning</mat-icon
    >
  </div>
</ng-template>
